module.exports = __webpack_public_path__ + "img/s1_t1_18.2dbfd480.jpeg";